import type { User } from '../model/index.tsx';
import { getUser, getUsers } from '../rest/index.tsx';
import { transformUser, transformUsers } from './transformers.tsx';

export const requestUser = (accountId: string): Promise<User> =>
	getUser(accountId).then(transformUser);

export const requestUsers = (query: string): Promise<User[]> =>
	getUsers(query).then(transformUsers);
